import { SortOrder } from 'antd/es/table/interface';
import { atom } from 'jotai';

export const defaultFilters = ['ALL_ALERTS'];

const searchTextAtom = atom('');
const sortByAtom = atom<{ key: string; order: SortOrder }>({ key: 'eventTime', order: 'descend' });
const tableFiltersAtom = atom<string[]>(defaultFilters);

export { searchTextAtom, sortByAtom, tableFiltersAtom };
